import React, { useEffect, useState } from "react";
import Header from "../header/Header";

function Strokerehab() {
  const [duration, setDuration] = useState(1);
  const [pricePerMonth] = useState(500);

  const handleDurationChange = (amount) => {
    const newDuration = duration + amount;
    if (newDuration > 0) {
      setDuration(newDuration);
    }
  };

  const totalPrice = duration * pricePerMonth;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <div className="bg2">
        <div className="bg3">
          <div style={{ textAlign: "center", position: "relative" }}>
            <img
              src="../style/img/Rehabserv/Strokerehab.jpg"
              className="pneumoban"
              alt="Pneumoban"
            />
           <h3 className="pneu1 text-white" style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)' }}>
  <b class="text-dark">Stroke Rehabilitation</b>
</h3>
<p className="pneu2 text-white" style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)' }}>
  <b class="text-white">
    Achieve a remarkable recovery with our best-in-class stroke rehabilitation program, crafted to help
    you reclaim independence and enhance your quality of life.
  </b>
</p>

          </div>
          <br />
          <div className="greenbg">
            <h3
              className="text-center text-white"
              style={{ fontWeight: "bold", fontFamily: "Poppins" }}
            >
              Package Highlights
            </h3>

            <div className="container">
              <div className="row">
                {[
                  {
                    imgSrc: "../style/img/resp/pneuicon2.png",
                    title: "Customized Recovery Plan",
                    description:
                      "An exclusive, highly personalized plan that adapts to your unique recovery journey, ensuring optimal progress every step of the way.",
                  },
                  {
                    imgSrc: "../style/img/resp/pneuicon2.png",
                    title: "Mobility Restoration and Balance Excellence",
                    description:
                      "Specialized exercises and expert techniques to restore movement, enhance balance, and build the foundation for safe, confident mobility.",
                  },
                  {
                    imgSrc: "../style/img/resp/pneuicon4.png",
                    title: "Strength and Endurance Enhancement",
                    description:
                      "Powerful strengthening programs designed to rebuild muscle, improve endurance, and prepare you for the activities that matter most.",
                  },
                  {
                    imgSrc: "../style/img/resp/pneuicon4.png",
                    title: "Speech and Cognitive Reawakening",
                    description:
                      "State-of-the-art therapy for speech, language, and cognitive recovery, empowering you to communicate effectively and confidently.",
                  },
                  {
                    imgSrc: "../style/img/resp/pneuicon4.png",
                    title: "Fall Prevention Expertise",
                    description: "Advanced fall prevention strategies tailored specifically for stroke recovery to keep you safe and secure.",
                  },
                  {
                    imgSrc: "../style/img/resp/pneuicon4.png",
                    title: "Functional Movement Mastery",
                    description:
                      "Precise training to regain critical daily movements, restoring your ability to engage fully in everyday life.",
                  },
                  {
                    imgSrc: "../style/img/resp/pneuicon4.png",
                    title: "Pain and Spasticity Relief",
                    description:
                      "Proven techniques to manage pain and ease muscle stiffness, so you can focus on recovery.",
                  },
                  {
                    imgSrc: "../style/img/resp/pneuicon4.png",
                    title: "Dedicated Caregiver Training and Support",
                    description:
                      "In-depth support for caregivers, ensuring they’re empowered to help you achieve the best outcomes.",
                  },
                ].map((item, index) => (
                  <div
                    className="col-sm-3 d-flex flex-column align-items-center text-center mb-4" // Added margin-bottom
                    key={index}
                  >
                    <div
                      className="blank d-flex flex-column justify-content-between"
                      style={{ height: "100%" }}
                    >
                      <img
                        src={item.imgSrc}
                        style={{
                          height: "60px",
                          display: "block",
                          margin: "40px auto",
                        }}
                        alt={item.title}
                      />
                      <h5 className="iconh">{item.title}</h5>
                      <p className="iconp">{item.description}</p>
                      <br />
                      <br />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div>
          <center>
            <h3
              style={{
                fontWeight: "800",
                fontFamily: "Poppins",
                fontSize: "30px",
              }}
            >
              Plan Purchase
            </h3>
            <h6
              style={{
                fontSize: "20px",
              }}
            >
              Choose Your Plan Duration
            </h6>
          </center>

          <div class="container">
            <center>
              <div
                class="greenbg priceboxgreen"
                style={{
                  borderRadius: "20px",
                  width: "750px",
                  height: "300px",
                }}
              >
                <br></br>
                <form
                  class="booking-form"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div class="form-group11">
                    <label class="boxresd text-dark">Duration Selector:</label>
                    <div class="diaginput" style={{ position: "relative" }}>
                      <span
                        class="subtraction text-dark"
                        onClick={() => handleDurationChange(-1)}
                        style={{
                          position: "absolute",
                          left: 20,
                          width: "20px",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                      >
                        -
                      </span>
                      <input
                        class="booktestdur"
                        name="duration"
                        value={`${duration} month${duration > 1 ? "s" : ""}`}
                        readOnly
                        style={{
                          textAlign: "center",
                          width: "100%",
                          padding: "0 40px",
                        }}
                      />
                      <span
                        class="addition text-dark  booktestadd"
                        onClick={() => handleDurationChange(1)}
                        style={{
                          position: "absolute",
                          right: 20,
                          bottom: "0px",
                          width: "20px",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                      >
                        +
                      </span>
                    </div>
                  </div>
                  <div class="form-group11">
                    <label class="boxresd text-dark">Price:</label>
                    <div
                      class="diaginput"
                      style={{ position: "relative", marginLeft: "10px" }}
                    >
                      <input
                        class="booktestdur"
                        style={{ width: "300px" }}
                        type="number"
                        name="totalPrice"
                        value={totalPrice}
                        readOnly
                      />
                    </div>
                  </div>
                </form>
                <br></br>
                <center>
                  <button
                    class="purchasebutton"
                    style={{
                      fontWeight: "600",
                      backgroundColor: "#fff",
                      color: "#466E6C",
                      borderRadius: "30px",
                    }}
                  >
                    Purchase
                  </button>
                </center>
              </div>
            </center>
            <br></br>
          </div>
        </div>
      </div>
    </>
  );
}

export default Strokerehab;
